// extracted by mini-css-extract-plugin
module.exports = {"input":"inputEdit_input__E27A3","input_box":"inputEdit_input_box__3-NyT","error":"inputEdit_error__2y27Z","err_msg":"inputEdit_err_msg__tNmYX"};